function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "416,213.335 394.665,213.335 394.665,192 373.333,192 373.333,213.335 352,213.335 352,234.667 373.333,234.667   373.333,298.666 394.665,298.666 394.665,234.667 416,234.667 "
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg175Montserrat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M309.334,160v117.333C309.334,334.487,384,352,384,352s74.666-17.513,74.666-74.667V160H309.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M309.334,277.333C309.334,334.487,384,352,384,352s74.666-17.513,74.666-74.667H309.334z"
  }), _ref2, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "256,0 256,48.896 215.853,89.043 256,89.043 256,166.957 203.464,166.957 256,219.492   256,256 232.281,256 166.957,190.664 166.957,256 89.043,256 89.043,178.276 11.331,256 0,256 0,207.104 40.147,166.957 0,166.957   0,89.043 52.536,89.043 0,36.508 0,0 23.719,0 89.043,65.336 89.043,0 166.957,0 166.957,77.724 244.669,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152.001 104.001,152.001 104.001,256 152.001,256 152.001,152.001 256,152.001   256,104.001 152.001,104.001 152.001,0 104.001,0 104.001,104.001 0,104.001 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.959 0,230.821 0,256 0,256 89.041,166.959  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.138,89.041 256,25.179 256,0 256,0 166.959,89.041  "
  })), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg175Montserrat);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };